import * as employee from '../services/employee';

export default {
  namespace: 'employee',
  state: {},
  effects: {
    //优惠券活动列表
    *getQueryActivityPage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(employee.getQueryActivityPage, values);
      yield put({
        type: 'save',
        payload: {
          activityList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    //删除
    *activityDelete({ payload: { values }, callback }, { call }) {
      const response = yield call(employee.activityDelete, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //审核
    *activityApprove({ payload: { values }, callback }, { call }) {
      const response = yield call(employee.activityApprove, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //取消
    *activityPause({ payload: { values }, callback }, { call }) {
      const response = yield call(employee.activityPause, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
